import { Notifier, Option, StringMapping, Terminable, Terminator, ValueMapping } from "@opendaw/lib-std";
import { AudioBusBoxAdapter } from "./AudioBusBoxAdapter";
import { AutomatableParameterFieldAdapter } from "../AutomatableParameterFieldAdapter";
export class AuxSendBoxAdapter {
    #context;
    #box;
    #terminator;
    #busChangeNotifier;
    #sendPan;
    #sendGain;
    #subscription = Terminable.Empty;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#terminator = new Terminator();
        this.#busChangeNotifier = this.#terminator.own(new Notifier());
        this.#terminator.own(box.targetBus.catchupAndSubscribe(() => {
            this.#subscription.terminate();
            this.#subscription = this.optTargetBus.match({
                none: () => {
                    this.#busChangeNotifier.notify(Option.None);
                    return Terminable.Empty;
                },
                some: adapter => adapter.catchupAndSubscribe(adapter => this.#busChangeNotifier.notify(Option.wrap(adapter)))
            });
        }));
        this.#sendPan = this.#terminator.own(new AutomatableParameterFieldAdapter(this.#context, this.#box.sendPan, ValueMapping.bipolar(), StringMapping.percent({ unit: "%", fractionDigits: 0 }), "panning"));
        this.#sendGain = this.#terminator.own(new AutomatableParameterFieldAdapter(this.#context, this.#box.sendGain, ValueMapping.DefaultDecibel, StringMapping.numeric({
            unit: "dB",
            fractionDigits: 1
        }), "gain"));
    }
    catchupAndSubscribeBusChanges(observer) {
        observer(this.optTargetBus);
        return this.#busChangeNotifier.subscribe(observer);
    }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get box() { return this.#box; }
    get indexField() { return this.#box.index; }
    get sendPan() { return this.#sendPan; }
    get sendGain() { return this.#sendGain; }
    get targetBus() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.targetBus.targetVertex.unwrap("no audioUnit").box, AudioBusBoxAdapter);
    }
    get optTargetBus() {
        return this.#box.targetBus.targetVertex
            .flatMap(target => Option.wrap(target.box.accept({
            visitAudioBusBox: (box) => this.#context.boxAdapters.adapterFor(box, AudioBusBoxAdapter)
        })));
    }
    delete() { this.#box.delete(); }
    terminate() {
        this.#terminator.terminate();
        this.#subscription.terminate();
    }
}
